import { combineReducers } from '@reduxjs/toolkit';
import TransitSlice from './TransitSlice';

const reducer = combineReducers({
    TransitSlice
});

export default reducer;
